import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haCaseListPatientFilter'
})
export class HaCaseListPatientFilterPipe implements PipeTransform {

  transform(patientData:any[], searchTerm:string): any[] {
    if(!patientData || !searchTerm){
      return patientData;
    }
    return patientData.filter(ad=>
      
      
        ad.fullName.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) !== -1 || 
        ad.patientId.toLowerCase().trim().indexOf(searchTerm.toLowerCase().trim()) !== -1 
     );
  }

}
